//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.17.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { RestClientBase } from "../../platform/RestClientBase";

export interface IUhfApiClient {
    /**
     * @return Success
     */
    getInstrumentationKey(): Promise<string>;
    /**
     * @return Success
     */
    getPartnersList(): Promise<string[]>;
    /**
     * @param partnerId (optional) 
     * @return Success
     */
    getPartnerHeaders(partnerId: string | undefined): Promise<string[]>;
    /**
     * @param partnerId (optional) 
     * @return Success
     */
    getPartnerFooters(partnerId: string | undefined): Promise<string[]>;
}

export class UhfApiClient extends RestClientBase implements IUhfApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> } = <any>window;
    private baseUrl: string = "";
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    /**
     * @return Success
     */
    getInstrumentationKey(): Promise<string> {
        let url_ = this.baseUrl + "/Telemetry/GetInstrumentationKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInstrumentationKey(_response);
        });
    }

    protected processGetInstrumentationKey(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Success
     */
    getPartnersList(): Promise<string[]> {
        let url_ = this.baseUrl + "/Uhf/GetPartnersList";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPartnersList(_response);
        });
    }

    protected processGetPartnersList(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param partnerId (optional) 
     * @return Success
     */
    getPartnerHeaders(partnerId: string | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/Uhf/GetPartnerHeaders?";
        if (partnerId === null)
            throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "partnerId=" + encodeURIComponent("" + partnerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPartnerHeaders(_response);
        });
    }

    protected processGetPartnerHeaders(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    /**
     * @param partnerId (optional) 
     * @return Success
     */
    getPartnerFooters(partnerId: string | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/Uhf/GetPartnerFooters?";
        if (partnerId === null)
            throw new Error("The parameter 'partnerId' cannot be null.");
        else if (partnerId !== undefined)
            url_ += "partnerId=" + encodeURIComponent("" + partnerId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPartnerFooters(_response);
        });
    }

    protected processGetPartnerFooters(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/* 
  The purpose of [RestClientBaseExt.ts] is to put the correct 'import' statement(s) in the generated typescript.
  There are alternatives, but this is cleaner way to do it.

  For more info: https://github.com/RicoSuter/NSwag/wiki/TypeScriptClientGenerator

  NOTE: this comment block will show up at the bottom of generated typescript.
*/